export default "__VITE_ASSET__DPDjQrrl__"